module.exports = __webpack_public_path__ + "img/cpp-file-format-symbol.bbb8a228.png";